// External modules
import React from 'react';
import { createRoot } from 'react-dom/client';

import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';

// Internal modules
import App from './App';
import Auth from './components/ac-react-components/auth';
import config from './config/config';
import * as serviceWorker from './serviceWorker';
import store from './components/common/store';
import './index.css';

import TagManager from 'react-gtm-module'

import { QueryClient, QueryClientProvider } from 'react-query';

const auth = new Auth(config);
const queryClient = new QueryClient();

const root = createRoot(document.getElementById('root'));
root.render(<BrowserRouter>
  <QueryClientProvider client={queryClient}>

  <Provider store={store}>
    <App auth={auth} config={config} />
  </Provider>
  </QueryClientProvider>
</BrowserRouter>)

 
const tagManagerArgs = {
    gtmId: config.GTMContainerId
}

TagManager.initialize(tagManagerArgs)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
